import SingularForm from "./SingularForm";
import * as Api from "@/api";

const formSlug = "samples-form";

const ContactFormWrapperKeys = ["title", "body", "body.2", "button"] as const;

const SingularFormSection = async () => {
  const formContent = await Api.PageService.getBareContentBySlug(
    formSlug,
    ContactFormWrapperKeys
  );

  return <section className="my-10">
    <SingularForm formContent={formContent} />
  </section>;
};

export default SingularFormSection;
